import React, { Fragment } from 'react';
import { GoogleMap, KmlLayer, LoadScript } from '@react-google-maps/api'
import './BibleGoogleMap.scss';
import NetworkNotification from '../NetworkNotification/NetworkNotification';


// https://react-google-maps-api-docs.netlify.app/

const center = {
    lat: 31.777444,
    lng: 35.234935
};

const containerStyle = {
    width: '100%',
    height: '100%'
  };

const options = {
    zoomControlOptions: {
        // the enum was not loading at runtime so I used the number instead
        // google.maps.ControlPosition.BOTTOM_LEFT = 1
        position: 1,
    },
    gestureHandling: 'greedy',
    styles: [{ "featureType": "administrative", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "hue": "#685c47" }, { "lightness": "-32" }, { "gamma": "2.28" }, { "saturation": "-22" }] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [{ "saturation": "-39" }, { "hue": "#ffc000" }, { "lightness": "-3" }] }, { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [{ "color": "#c1d9b5" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#86b1d7" }] }, { "featureType": "water", "elementType": "geometry.stroke", "stylers": [{ "color": "#00a7ea" }, { "weight": "7.87" }] }],
    fullscreenControl: false,
    mapTypeId: 'terrain',
}

interface IBibleGoogleMapProps {
    kmlUrl: string
}

const BibleGoogleMap: React.FC<IBibleGoogleMapProps> = (props) => {

    // wrapping to a function is useful in case you want to access `window.google`
    // to eg. setup options or create latLng object, it won't be available otherwise
    // feel free to render directly if you don't need that
    const onLoad = React.useCallback(
        function onLoad(mapInstance: any) {
            // do something with map Instance
        }, []
    )

    const renderMap = () => {

        return (
        <Fragment>
            <LoadScript googleMapsApiKey="AIzaSyCzUAsQgEmODsHNTBHoE9I1giA6pxtXlcM">
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    options={options}
                    center={center}
                    zoom={2}
                    tilt={45}
                >
                    <KmlLayer
                        options={{ suppressInfoWindows: false, preserveViewport: false }}
                        url={props.kmlUrl} />
                </GoogleMap>
            </LoadScript>
            <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to view maps."></NetworkNotification>
        </Fragment>
        )
    }

    return renderMap()
};

export default BibleGoogleMap;